<template>
  <v-card :loading="loading" :disabled="disabled">
    <v-card-title class="px-6">
      Monthly Active Users
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="px-6">
      <div style="width: 100%; height: 100%;">
        <canvas ref="trendChart" height="250"></canvas>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import Chart from "chart.js";
export default {
  name: "ActiveUserTrendCard",
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data: () => ({
    chart: null
  }),
  watch: {
    trendId(val) {
      let array = val.split("|");
      let change = { trendType: array[0], trendCoreValueId: array[1] };
      this.$emit("change", change);
    },
    billing_trend() {
      this.updateChart();
    }
  },
  computed: {
    datasets() {
      let primary = this.billing_trend.map(x => {
        return { t: x.date, y: x.value };
      });
      let list = [
        {
          data: primary,
          fill: false,
          borderColor: this.$vuetify.theme.themes.light.accent
        }
      ];
      return list;
    },
    ...mapGetters({
      billing_trend: "billing/billing_trend"
    })
  },
  mounted() {
    this.updateChart();
  },
  methods: {
    updateChart() {
      Chart.defaults.global.defaultFontColor = this.$vuetify.theme.themes.light.secondarytext;
      Chart.defaults.global.defaultFontSize = 10;
      if (this.chart) {
        this.chart.destroy();
      }
      this.chart = new Chart(this.$refs.trendChart, {
        type: "line",
        data: {
          datasets: this.datasets
        },
        options: {
          legend: { display: false },
          tooltips: {
            enabled: false
          },
          elements: {
            point: {
              radius: 0
            }
          },
          scales: {
            yAxes: [
              {
                ticks: { min: 0, padding: 8, maxTicksLimit: 5 },
                gridLines: {
                  display: true,
                  drawTicks: false,
                  drawOnChartArea: false
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  display: true,
                  drawTicks: false,
                  drawOnChartArea: false
                },
                type: "time",
                ticks: {
                  maxTicksLimit: 5,
                  padding: 8
                },
                time: {
                  unit: "month",
                  unitStepSize: 1
                }
              }
            ]
          },
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              display: false
            }
          }
        }
      });
    }
  }
};
</script>
